if (!customElements.get('product-gallery')) {
  customElements.define(
    'product-gallery',
    class ProductGallery extends HTMLElement {
      connectedCallback() {
        this.setNodeSelectors();
        this.setResizeEvents();
        this.setEventListeners();
        this.setCarouselState();
        this.setInitialState();
      }

      /**
       * Sets the node selectors.
       */
      setNodeSelectors() {
        this.nodeSelectors = {
          carousel: this.querySelector('[js-product-gallery="carousel"]'),
          videoButton: this.querySelector('[js-product-gallery="videoButton"]'),
          videoSlide: this.querySelector('[js-product-gallery="videoSlide"]'),
          loadMore: this.querySelector('[js-product-gallery="loadMore"]'),
        };
      }

      /**
       * Sets the event handlers.
       */
      setEventListeners() {
        if (this.nodeSelectors.videoButton && this.nodeSelectors.videoSlide) {
          this.nodeSelectors.videoButton.addEventListener('click', () => {
            this.goToVideoSlide();
          });
        }
        if (this.nodeSelectors.loadMore) {
          this.nodeSelectors.loadMore.addEventListener('click', () => {
            this.loadNextBatch();
          });
        }
      }

      /**
       * Navigates the carousel to the video slide, if it exists.
       */
      goToVideoSlide() {
        if (!this.nodeSelectors.videoSlide || !this.carousel) {
          return;
        }

        this.carousel.slideTo(Number(this.nodeSelectors.videoSlide.dataset.index) - 1);
      }

      /**
       * Sets the window resize events.
       */
      setResizeEvents() {
        window.addEventListener(
          'resize',
          debounce(() => this.setCarouselState())
        );
      }

      /**
       * Sets the carousel state.
       */
      setCarouselState() {
        const { large } = getBreakpoints();

        if (!this.nodeSelectors.carousel) {
          return;
        }

        if (window.matchMedia(`(min-width: ${large}px)`).matches) {
          this.destroyCarousel();
          return;
        }

        if (this.carousel && !this.carousel.destroyed) {
          return;
        }

        this.constructCarousel();
      }

      /**
       * Constructs the carousel.
       */
      constructCarousel() {
        this.carousel = new Swiper(this.nodeSelectors.carousel, {
          scrollbar: {
            el: '.product-gallery__scrollbar',
          },
        });
      }

      /**
       * Destroys the carousel.
       */
      destroyCarousel() {
        if (!this.carousel) {
          return;
        }

        this.carousel.destroy(true, true);
      }

      setInitialState() {
        this.batchSize = parseInt(this.dataset.initialLimit) || 4;
        this.remainingSlides = Array.from(this.querySelectorAll('.swiper-slide.is-hidden-desktop'));
      }

      loadNextBatch() {
        const nextBatch = this.remainingSlides.splice(0, this.batchSize);
        nextBatch.forEach(slide => slide.classList.remove('is-hidden-desktop'));

        if (this.carousel) {
          this.carousel.update();
        }

        if (this.remainingSlides.length === 0 && this.nodeSelectors.loadMore) {
          this.nodeSelectors.loadMore.remove();
        }
      }
    }
  );
}
